module.exports = __webpack_public_path__ + "token_value_earned.b85b22a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/token_value_earned.png
// module id = 469
// module chunks = 0